export const FETCH_REASONS = 'AGENT_COACHING_FETCH_REASONS';
export const RECEIVED_REASONS = 'RECEIVED_COACHING_REASONS';
export const FETCH_STATUSES = 'AGENT_COACHING_FETCH_STATUSES';
export const RECEIVED_STATUSES = 'RECEIVED_COACHING_STATUSES';
export const FETCH_OPPORTUNITIES = 'AGENT_COACHING_FETCH_OPPORTUNITIES';
export const RECEIVED_OPPORTUNITIES = 'RECEIVED_OPPORTUNITIES';
export const FETCH_KPIS = 'AGENT_COACHING_FETCH_KPIS';
export const RECEIVED_KPIS = 'RECEIVED_KPIS';
export const FETCH_FORM_TYPES = 'FETCH_FORM_TYPES';
export const RECEIVED_FORM_TYPES = 'RECEIVED_FORM_TYPES';
export const FETCH_SINGLE_OPPORTUNITY = 'AGENT_COACHING_FETCH_SINGLE_OPPORTUNITY';
export const RECEIVED_SINGLE_OPPORTUNITY = 'RECEIVED_SINGLE_OPPORTUNITY';
export const CLEAR_SINGLE_OPPORTUNITY = 'CLEAR_SINGLE_OPPORTUNITY';
export const FETCH_AGENTS = 'AGENT_COACHING_FETCH_AGENTS';
export const RECEIVED_AGENTS = 'RECEIVED_AGENTS';
export const FETCH_TEAMS = 'AGENT_COACHING_FETCH_TEAMS';
export const RECEIVED_TEAMS = 'RECEIVED_TEAMS';
export const FETCH_CALL_DETAILS = 'AGENT_COACHING_FETCH_CALL_DETAILS';
export const RECEIVED_CALL_DETAILS = 'RECEIVED_CALL_DETAILS';
export const FETCH_STATUS_QUESTIONS = 'AGENT_COACHING_FETCH_STATUS_QUESTIONS';
export const RECEIVED_STATUS_QUESTIONS = 'RECEIVED_STATUS_QUESTIONS';
export const CLEAR_STATUS_QUESTIONS = 'CLEAR_STATUS_QUESTIONS';
export const FETCH_OPPORTUNITY_ANSWERS = 'AGENT_COACHING_FETCH_OPPORTUNITY_ANSWERS';
export const RECEIVED_OPPORTUNITY_ANSWERS = 'RECEIVED_OPPORTUNITY_ANSWERS';
export const POST_OPPORTUNITY = 'AGENT_COACHING_POST_OPPORTUNITY';
export const POSTED_OPPORTUNITY = 'POSTED_OPPORTUNITY';
export const POST_EXISTING_OPPORTUNITY = 'AGENT_COACHING_POST_EXISTING_OPPORTUNITY';
export const POSTED_EXISTING_OPPORTUNITY = 'POSTED_EXISTING_OPPORTUNITY';
export const ADD_UI_ERROR = 'ADD_UI_ERROR';
export const REMOVE_UI_ERROR = 'REMOVE_UI_ERROR';

// todo think of better naming or enumeration
export const STATUS_IDS = {
  new: 1,
  follow: 2,
  completed: 3,
}

export const MAX_STATUS_ID = 3;

export const ANSWER_TYPES = {
  text: 1,
  dropDown: 2,
};

export const SECTION_IDS = {
  questionSection: 'questionSection',
  callDetailsSection: 'callDetailsSection',
};

export const ROUTES = {
  agentCoachingPage: '/AgentCoaching',
  opportunityPage: '/AgentCoaching/Opportunity/:opportunityId?',
};

// where possible, these should match properties in swagger model
export const CALL_DETAIL_INPUT_IDS = {
  team: 'team',
  salesAgent: 'salesAgent',
  reason: 'reason',
  targetKpi: 'targetKpi',
  formType: 'coachingFormType',
  dateOfCall: 'dateOfCall',
  callLogId: 'callLogId',
  kpiPerformance: 'kpiPerformance',
};

export const QUESTION_GROUP_IDS = {
  activeQuestions: 'activeQuestions',
  inactiveQuestions: 'inactiveQuestions',
};

export const UI_ERROR_REFS = {
  callLogIdError: 'callLogIdError',
};

export const TEAM_MANAGER_TYPES = {
  0: 'Team Lead',
  1: 'Team Manager',
  2: 'Senior Sales Manager'
}

export const PROCESS_FLOW_NOT_REQUIRED = {
  'Evaluation Duration': true,
  'Daily 1st Hour Evaluation': true,
  'Daily 2nd - 4th Hour Evaluation': true,
  'Daily 5th - 7th Hour Evaluation': true,
  'Daily Last Hour/Power Hour Evaluation': true,
}

export const PROCESS_FLOW_REQUIRED_IDS = [23, 28, 29, 30, 31, 32];


// WEBPACK FOOTER //
// ./src/features/agent-coaching/redux/constants.js